import { appTypeId } from '../../../models/application-types';

export class Controller {

    /** @ngInject */
    constructor(
        $state,
        AddNewApplicationResource,
        Alert,
        SlackInfoService,
    ) {
        this.$state = $state;
        this.AddNewApplicationResource = AddNewApplicationResource;
        this.Alert = Alert;
        this.SlackInfoService = SlackInfoService;
    }

    $onInit() {
        if (!this.state || !this.code) {
            return;
        }

        this.SlackInfoService.processSlackAuth
            .save({companyId: this.companyId, state: this.state, code: this.code}, {})
            .$promise
            .then(data => this.Alert('success', 'company.slack-info.installed', {teamID: data.teamName}))
            .catch(() => this.Alert('danger', 'company.slack-info.error'))
            .finally(() => this.$state.go('company.slack-info', {state: null, code: null}))
    }

    getSlackAuthorizeUrl() {
        this.SlackInfoService.getSlackAuthorizeUrl
            .get({companyId: this.companyId,})
            .$promise
            .then(
                data => window.location.assign(data.url),
                () => this.Alert('danger', 'company.slack-info.error')
            );
    }

    showAddApplicationModal() {
        this.AddNewApplicationResource
            .createSecureApp(this.companyId, appTypeId('slack'))
            .then(app => this.$state.go('company.manage-application', {appId: app.id}))
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/slack-info/slack-info.controller.js